import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import InitiativeValidations from 'scaleflow/validators/initiative';

export default class QuickAddsInitiativeComponent extends Component {
  @service store;
  @service router;
  @service betaToggle;
  @tracked isSaving = false;

  initiativeValidations = InitiativeValidations;
  initiative = {
    title: '',
    status: this.deriveDefaultStatusFromFiltersInURL(),
    summary: { ops: [] },
  };

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    this.isSaving = true;
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const initiative = this.store.createRecord('initiative', {
        title: changeset.title,
        status: changeset.status,
        abbreviation: changeset.abbreviation,
        summary: changeset.summary,
      });
      await initiative.save();
      await this.args?.onItemSaved?.(initiative);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    } finally {
      this.isSaving = false;
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss?.();
  }

  @action
  setDelta(changeset, e) {
    changeset.set('summary', e);
  }

  @action
  onStatusSelect(changeset, e) {
    changeset.set('status', e.value);
  }

  deriveDefaultStatusFromFiltersInURL() {
    let status = 'DRAFT';
    const statusFilters =
      this.router?.currentRoute?.queryParams?.status ?? '[]';
    if (statusFilters === undefined) return status;
    try {
      const parsedStatusFilters = JSON.parse(statusFilters);
      if (parsedStatusFilters.length === 0) return status;
      status = parsedStatusFilters.pop();
    } catch (err) {
      console.debug(err);
    }
    return status;
  }

  willDestroy() {
    this.isSaving = false;
    super.willDestroy(...arguments);
  }
}
